import PropTypes from 'prop-types';

export const CardGridPropTypes = {
  /**
   * The width of the grid.
   * @type {string}
   */
  width: PropTypes.string,
  /**
   * The Children of the grid, this is controled by the storybook since it has to come in a specific format.
   * @type {node}
   */
  children: PropTypes.node,
  /**
   * The spacing between columns.
   * @type {number}
   */
  columnSpacing: PropTypes.number,

  /**
   * The spacing between rows.
   * @type {number}
   */
  rowSpacing: PropTypes.number,
};
